import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { InfoCard } from "./SpendOverview";
import ailoader from "../../assets/ailoader.gif";
export const LoadingGif = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
        width: "auto",
      }}
    >
      <img
        src={ailoader}
        alt="Loading..."
        style={{ width: "30px", height: "30px" }}
      />
    </Box>
  );

export const AnimatedInfoCard = styled(InfoCard)`
opacity: 0;
transform: translateY(20px);
animation: fadeIn 0.5s ease forwards;
animation-delay: ${(props) => props.delay}ms;

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;
